// Shared password-validation logic that was duplicated across
// UserManagement / UserChatManagement / UserGroupDetail (add-user and
// change-password flows). Each method body is behavior-identical to the local
// copies it replaces. The views keep their own THIN watchers so per-file
// if/else-if semantics stay untouched:
//  - UserManagement's "user.password" watcher keeps its historical double-if
//    match handling locally (it does NOT use evaluatePasswordChecks),
//  - UserGroupDetail's "edit.confirmpassword" watcher keeps its extra null
//    guards locally (it does NOT use evaluateConfirmPasswordChecks).
export default {
  methods: {
    // Sets the five format flags + statusFormatPassword.
    // Returns true when the password was non-empty (i.e. the checks ran).
    evaluatePasswordFormatChecks(password) {
      if (password != null && password != undefined && password != "") {
        this.checkLengthPassword = password.length >= 8;
        this.checkLowercaseLetter = /[a-z]/.test(password);
        this.checkUppercaseLetter = /[A-Z]/.test(password);
        this.checkNumber = /\d/.test(password);
        this.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(password);
        if (
          this.checkLengthPassword &&
          this.checkLowercaseLetter &&
          this.checkUppercaseLetter &&
          this.checkNumber &&
          this.checkSpecialCharacter
        ) {
          this.statusFormatPassword = true;
        } else {
          this.statusFormatPassword = false;
        }
        return true;
      }
      return false;
    },
    // Format checks + the common else-if password-match variant used by the
    // password watchers.
    evaluatePasswordChecks(password, confirmpassword) {
      if (this.evaluatePasswordFormatChecks(password)) {
        if (password == confirmpassword) {
          this.checkPasswordMatch = true;
        } else if (confirmpassword != null && confirmpassword.length > 0) {
          this.checkPasswordMatch = false;
        }
      }
    },
    // Body of the confirm-password watchers.
    evaluateConfirmPasswordChecks(password, confirmpassword) {
      this.checkPasswordMatch = password == confirmpassword;
      if (
        password == confirmpassword &&
        this.checkLengthPassword &&
        this.checkLowercaseLetter &&
        this.checkUppercaseLetter &&
        this.checkNumber &&
        this.checkSpecialCharacter
      ) {
        this.statusPassword = true;
      } else {
        this.statusPassword = false;
      }
    },
    // The 13-condition guard at the head of saveChangePassword
    // (verified byte-identical across the three views).
    isChangePasswordValid() {
      return (
        this.edit.password != "" &&
        this.edit.confirmpassword != "" &&
        this.edit.password != null &&
        this.edit.confirmpassword != null &&
        this.edit.password != undefined &&
        this.edit.confirmpassword != undefined &&
        this.edit.password == this.edit.confirmpassword &&
        this.checkPasswordMatch &&
        this.checkLengthPassword &&
        this.checkLowercaseLetter &&
        this.checkUppercaseLetter &&
        this.checkNumber &&
        this.checkSpecialCharacter
      );
    },
    // Resets the six requirement flags to their pristine (all-true) state.
    // Dialog flags, show1/2/3/4 toggles and null-vs-"" field resets stay
    // file-local — they genuinely differ between the views.
    resetPasswordCheckFlags() {
      this.checkLengthPassword = true;
      this.checkLowercaseLetter = true;
      this.checkUppercaseLetter = true;
      this.checkNumber = true;
      this.checkSpecialCharacter = true;
      this.checkPasswordMatch = true;
    },
  },
};
